import { normalizeObjError } from '../../utils/adaByron';
import { api } from '../../utils/monitoringUtils';
import { MethodType } from '../../utils/types';
import Request, { getMockedInfo } from '../../utils/request';
import Sonda from '../../utils/sonda';
import { getThirdPartyEndPoint } from '../../utils/adabyronThirdUtils';
import {
  normalizeGetMobileInsurance,
  normalizeGetMobileInsuranceLegals,
} from './normalizers/index';

enum PATHS {
  GET_MOBILE_INSURANCE = 'movistar/web/rates',
  GET_MOBILE_INSURANCE_LEGALS = 'options/FOOTER_LEGAL_COL',
}

enum THIRD_KEY {
  KEY = 'TS',
}

export const getMobileInsuranceError = (response: any) => {
  return normalizeObjError(response);
};

export const getMobileInsuranceSuccess = (xhr: any) => {
  const { response } = xhr;
  const { result } = JSON.parse(response);
  return normalizeGetMobileInsurance(result);
};

export const getMobileInsurance = (
  data: {
    productOffering: string;
    storage: string;
  },
  context: any,
  idFront = 'VT',
): Promise<any> => {
  const idRequest = api.getUUID(idFront);
  const { telco: connectionData } = context.environment;
  const { headers } = connectionData;
  const { name } = context.environment;

  const sonda = new Sonda({
    eventName: 'MOBILE_INSURANCE.GET_MOBILE_INSURANCE',
    context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API',
  });
  const { productOffering, storage } = data;
  const thirdHostUrl = getThirdPartyEndPoint(
    context,
    PATHS.GET_MOBILE_INSURANCE,
    THIRD_KEY.KEY,
  );
  const URL_API = `${thirdHostUrl}${productOffering}/${storage}?${idRequest}`;
  const mockInfo = getMockedInfo('getMobileInsurance', name);

  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onError: (response) => getMobileInsuranceError(response),
      onSuccess: (response) => getMobileInsuranceSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};

export const getMobileInsuranceLegalsError = (response: any) => {
  return normalizeObjError(response);
};

export const getMobileInsuranceLegalsSuccess = (xhr: any) => {
  const { response } = xhr;
  const { html } = JSON.parse(response);
  return normalizeGetMobileInsuranceLegals(html);
};

export const getMobileInsuranceLegals = (
  data: {
    productOffering: string;
    storage: string;
  },
  context: any,
  idFront = 'VT',
): Promise<any> => {
  const idRequest = api.getUUID(idFront);
  const { telco: connectionData } = context.environment;
  const { headers } = connectionData;
  const { name } = context.environment;

  const sonda = new Sonda({
    eventName: 'MOBILE_INSURANCE.GET_MOBILE_INSURANCE_LEGALS',
    context,
    uniqueId: idRequest,
    origin: 'ADABYRON-API',
  });
  const { productOffering, storage } = data;
  const thirdHostUrl = getThirdPartyEndPoint(
    context,
    PATHS.GET_MOBILE_INSURANCE_LEGALS,
    THIRD_KEY.KEY,
  );
  const URL_API = `${thirdHostUrl}${productOffering}/${storage}?${idRequest}`;
  const mockInfo = getMockedInfo('getMobileInsuranceLegals', name);
  try {
    const request = new Request({
      method: MethodType.GET,
      endpoint: URL_API,
      onError: (response) => getMobileInsuranceLegalsError(response),
      onSuccess: (response) => getMobileInsuranceLegalsSuccess(response),
      sonda,
      headers,
      mockInfo,
    });

    return request.makeRequest();
  } catch (err) {
    sonda.errorJs(err);
    return null;
  }
};
